import { Input } from "@/components/ui/input";
import { Spinner } from "@/components/ui/spinner";
import { MdSearch } from "react-icons/md";

const SearchInput = ({ isSearching, handleSearch, placeholder, width, height }) => {
  return (
    <div className={`relative ${width ? width : "w-full sm:w-auto"}`}>
      <MdSearch className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 transform text-xl text-gray-400" />
      <Input
        type="text"
        placeholder={placeholder}
        onChange={(e) => handleSearch(e.target.value)}
        className={`bg-white pr-10 pl-10 ${height ? height : ""}`}
      />
      {isSearching && (
        <div className="absolute top-1/2 right-3 -translate-y-1/2 transform">
          <Spinner className="text-primary" />
        </div>
      )}
    </div>
  );
};

export default SearchInput;
